<section class="brands__page">
  <header>
    <h1>Marcas</h1>

    <div class="quantity-products">
      <p>{{ sellers.length }}+ Produtos</p>
    </div>
  </header>

  <body>
    <nz-row>
      <nz-col
        *ngFor="let seller of sellers; let i = index"
        [nzXs]="5"
        [nzSm]="5"
        [nzLg]="3"
        [nzXl]="2"
        class="w-100 d-flex"
      >
        <div class="brand-card" (click)="goToProducts('seller', seller)">
          <img
            class="brand-img"
            [src]="seller?.image_url ? seller.image_url : '/assets/img/default-coupon.svg'"
            onerror="this.onerror=null; this.src='/assets/img/default-coupon.svg'"
            alt="Logo da loja"
          />
          <p class="brand-name">
            {{ seller?.business_name }}
          </p>
        </div>
      </nz-col>
    </nz-row>
  </body>
</section>
